import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { roomDetails } from "@/lib/rooms";
  import RoomView from "@/components/RoomView.vue";
  import {useRoomPrice} from "@/composables/roomPrices";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'mainhouse',
  setup(__props) {

  let room = roomDetails.mainhouse;
  room = useRoomPrice(room);


return (_ctx: any,_cache: any) => {
  const _component_HeaderDefault = _resolveComponent("HeaderDefault")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderDefault, {
        title: "The Main House",
        subtitle: ""
      }),
      _createVNode(RoomView, { room: _unref(room) }, null, 8, ["room"])
    ]),
    _: 1
  }))
}
}

})